import { Routes, Route, Link } from "react-router-dom";

import { DialogProvider } from "./components/DialogProvider";
import { AuthProvider } from "./auth/AuthProvider";
import { AuthGuard } from "./auth/AuthGuard";
import { hasGroup, useAuth, userDisplayName } from "./auth/AuthContext";

import RecordingsList from "./pages/RecordingsList";
import RecordingView from "./pages/RecordingView";
import PromptsPage from "./pages/PromptsPage";
import LoginPage from "./pages/LoginPage";
import TagsPage from "./pages/TagsPage";

/** Имя admin-группы в Authentik. Совпадает с recorder-backend AUTHENTIK_ADMIN_GROUP. */
const ADMIN_GROUP = "recordings-admin";

/*
 * Routes:
 *   /                — список записей (под AuthGuard)
 *   /r/:id           — плеер записи (под AuthGuard)
 *   /api/auth/*      — OIDC и сессии обрабатываются backend.
 */
export default function App() {
  return (
    <AuthProvider>
      <DialogProvider>
      <div className="app">
        <Header />
        <main className="app-main">
          <Routes>
            <Route
              path="/"
              element={
                <AuthGuard>
                  <RecordingsList />
                </AuthGuard>
              }
            />
            <Route
              path="/r/:id"
              element={
                <AuthGuard>
                  <RecordingView />
                </AuthGuard>
              }
            />
            <Route
              path="/prompts"
              element={
                <AuthGuard>
                  <PromptsPage />
                </AuthGuard>
              }
            />

            <Route path="/login" element={<LoginPage />} />
            <Route path="/tags" element={<AuthGuard><TagsPage /></AuthGuard>} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
      </div>
      </DialogProvider>
    </AuthProvider>
  );
}

function Header() {
  const { user, signout } = useAuth();
  return (
    <header className="app-header">
      <Link to="/" className="app-title">
        NAN Recordings
      </Link>
      {user && (
        <nav className="app-nav">
          <Link to="/">Записи</Link>
          <Link to="/tags">Метки</Link>
          {hasGroup(user, ADMIN_GROUP) && <Link to="/prompts">Промпты</Link>}
        </nav>
      )}
      {user && (
        <div className="app-header-user">
          <span className="muted">{userDisplayName(user)}</span>
          <button
            type="button"
            className="link-button"
            onClick={() => {
              signout().catch((err) =>
                // eslint-disable-next-line no-console
                console.error("[auth] signout failed", err),
              );
            }}
          >
            Выйти
          </button>
        </div>
      )}
    </header>
  );
}

function NotFound() {
  return (
    <div className="page">
      <h1>404</h1>
      <p>Страница не найдена.</p>
      <Link to="/">← К списку записей</Link>
    </div>
  );
}
